module.exports = __webpack_public_path__ + "fonts-29d971b67627ca6aa755d4c35135f463-GT-Eesti-Pro-Display-Medium-subset.woff2";